import Head from 'next/head';
import Script from 'next/script';
import {useCallback} from 'react';
import {getEnv} from '../../../common/env/env';
import {requestContext} from '../../../common/requestContext';
import {IS_CLIENT_SIDE} from '../../../common/shared/utils/constants';
import {updateEmoticon} from '../util/updateEmoticon';

export function EmoticonScript() {
  const onLoad = useCallback(() => {
    window.Kakao.init(getEnv().kakaoSdkId);
    updateEmoticon();
  }, []);

  const {isMobile} = requestContext.requestInfo.display;
  return (
    <>
      {/* 이미 script가 로드되어 window에 박혀있으면 스크립트를 추가 로드하지 않습니다. */}
      {IS_CLIENT_SIDE && !window?.Kakao?.Emoticon && (
        <Script src={getEnv().kakaoEmoticonSdkJs} onLoad={onLoad} />
      )}
      <Head>
        <link
          rel="stylesheet"
          type="text/css"
          href={
            isMobile
              ? getEnv().kakaoEmoticonSdkCssMobile
              : getEnv().kakaoEmoticonSdkCssPc
          }
        />
      </Head>
    </>
  );
}
